import React, { useEffect, useRef } from 'react';
import '../styles/Statistics.scss';

const Stamp = `${process.env.REACT_APP_S3_URL}trustedStamp.svg`;
const StampMobile = `${process.env.REACT_APP_S3_URL}trustedStampMobile.svg`;
const IDFC = `${process.env.REACT_APP_S3_URL}IDFC.svg`;
const JK = `${process.env.REACT_APP_S3_URL}JK.svg`;
const AxisBank = `${process.env.REACT_APP_S3_URL}axisBank.svg`;
const CEdge = `${process.env.REACT_APP_S3_URL}CEdge.svg`;
const CoinDCX = `${process.env.REACT_APP_S3_URL}CoinDCX.svg`;
const Decentro = `${process.env.REACT_APP_S3_URL}Decentro.svg`;
const Easebuzz = `${process.env.REACT_APP_S3_URL}Easebuzz.svg`;
const OmniCard = `${process.env.REACT_APP_S3_URL}Omnicard.svg`;
const OxyMoney = `${process.env.REACT_APP_S3_URL}OxyMoney.svg`;
const Suryoday = `${process.env.REACT_APP_S3_URL}Suryoday.svg`;
const YesBank = `${process.env.REACT_APP_S3_URL}yesBank.svg`;
const AuroFintech = `${process.env.REACT_APP_S3_URL}Auro fintech.jpg`;
const EBIX = `${process.env.REACT_APP_S3_URL}EBIX.svg`;
const iMoneyPay = `${process.env.REACT_APP_S3_URL}iMoneyPay.svg`;
const Payworld = `${process.env.REACT_APP_S3_URL}Payworld.svg`;

const banks = [
    { id: 1, name: 'Axis Bank', logo: AxisBank },
    { id: 2, name: 'Yes Bank', logo: YesBank },
    { id: 3, name: 'CEdge', logo: CEdge },
    { id: 4, name: 'CoinDCX', logo: CoinDCX },
    { id: 5, name: 'Decentro', logo: Decentro },
    { id: 6, name: 'Easebuzz', logo: Easebuzz },
    { id: 7, name: 'Omni Card', logo: OmniCard },
    { id: 8, name: 'Oxy Money', logo: OxyMoney },
    { id: 9, name: 'Suryoday', logo: Suryoday },
    { id: 11, name: 'EBIX', logo: EBIX },
    { id: 12, name: 'iMoneyPay', logo: iMoneyPay },
    { id: 13, name: 'Payworld', logo: Payworld },
    { id: 14, name: 'IDFC', logo: IDFC },
    { id: 15, name: 'JK', logo: JK }
];

const statistics = [
    { id: 1, label: 'Banks', value: '90+' },
    { id: 2, label: 'Fintechs', value: '30+' },
    { id: 3, label: 'Transactions \n Processed', value: '13+ Bn' }
];

const Statistics: React.FC = () => {

    const banksListRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const banksListStats = banksListRef.current;
        if (!banksListStats) return;

        const autoScroll = () => {
            banksListStats.scrollBy({ left: 1, behavior: "smooth" });

            // When half of the items are scrolled, reset scroll position smoothly
            if (banksListStats.scrollLeft >= banksListStats.scrollWidth / 2) {
                banksListStats.scrollLeft = 0;
            }
        };

        const scrollInterval = setInterval(autoScroll, 10); // Adjust speed if needed

        return () => clearInterval(scrollInterval); // Cleanup on unmount
    }, []);

    return (
        <div>
            <section className="statistics-section">
                <div className='heading-section'>
                    <div style={{flex:1}}>
                        <h2>
                        Simplified&nbsp;
                        <strong 
                        style={{
                            background: 'linear-gradient(81.88deg, #E51A4B 0%, #E36F8A 107.04%)',
                            WebkitBackgroundClip: 'text',
                            WebkitTextFillColor: 'transparent',
                            backgroundClip: 'text', // For Firefox
                            color: 'transparent',
                          }}
                        >Digital Payments </strong> 
                        for Seamless Transactions
                        </h2>
                    </div>
                    <div className='stamp'>
                        <img src={Stamp} alt ='' />
                    </div>
                </div>
                <div className='stats-stamp'>
                    <div className='stats'>
                        {statistics.map(stat => (
                            <div key={stat.id} className="stat">
                                <h3>{stat.value}</h3>
                                <p>{stat.label}</p>
                            </div>
                        ))}
                    </div>
                    <div className='stamp-mobile'>
                        <img src={StampMobile} alt ='' />
                    </div>
                </div>
            </section>
            {/* <div className="banks-list-container">
                <div ref={banksListRef} className='banks-list-stats'>
                    {
                        [...banks, ...banks].map((bank)=>{
                            return (
                                <img style={{ height:36 }} src={bank.logo} alt='' />
                            )
                        })
                    }
                </div>
            </div> */}

        </div>
    );
};

export default Statistics;
